//
import { Cliente } from '../../shared/entity/Cliente';
import { celularMask, validarEmail } from '../../shared/helper';
import { useNavigation } from '@react-navigation/native';
import React, { useState, useEffect } from 'react';
import { StyleSheet, Text } from 'react-native';
import { TextInput } from 'react-native-paper';
import authApi from '../../apis/authApi';
import clienteApi from '../../apis/clienteApi';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING, TXT_G, TXT_M } from '../../constants';
import { useAlert } from '../../redux/alert/alertHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Button from '../Generic/Button';
import Form from '../Generic/Form';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import Title from '../Generic/Title';

const VerificacaoPage: React.FC = () => {
  const navigation = useNavigation();
  const [sessao, login, logout, revalidate] = useSessao();
  const [celular, setCelular] = useState('');
  const [codigo, setCodigo] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [mostrarAlert] = useAlert();

  useEffect(() => {
    if (sessao.cliente) {
      setCelular(celularMask(sessao.cliente.celular));
    }
  }, [sessao]);

  const enviarCodigoSMS = async () => {
    try {
      const novoCelular = celular.replace(/\D/g, '');
      if (novoCelular.length !== 11) {
        mostrarAlert(
          'Erro',
          'Celular inválido. Por favor, informe os dois dígitos do DDD seguido dos 9 dígitos do número do celular.'
        );
      }
      await clienteApi.enviarCodigoSMS(novoCelular);
      mostrarAlert(
        'SMS enviado!',
        'Aguarde até 2 minutos para receber o SMS com o codigo de confirmação que foi enviado para seu celular.'
      );
      setEnviado(true);
    } catch (err) {
      mostrarAlert(
        'Erro',
        'Ocorreu um erro ao enviar o SMS para seu celular. Por favor, verifique o número e tente novamente.'
      );
    }
  };

  const verificarCodigoSMS = async () => {
    try {
      await clienteApi.verificarCodigoSMS(codigo);
      revalidate();
      mostrarAlert('Sucesso!', 'Seu celular foi validado.');
      navigation.goBack();
    } catch (err) {
      mostrarAlert('Erro', err.data);
    }
  };

  return (
    <PageContainer header={<Header goBack />}>
      {!enviado ? (
        <Form style={styles.form}>
          <Title>Verificar Celular</Title>
          <Text
            style={{
              marginBottom: 10,
              color: colors.darkGrey,
              textAlign: 'center',
              fontSize: TXT_M
            }}
          >
            Vamos enviar um código em um SMS para seu celular. Assim que recebê-lo, coloque no campo
            abaixo.
          </Text>

          <TextInput
            label={'Celular'}
            maxLength={15}
            placeholder={'(99) 9 9999-9999'}
            onChangeText={(txt) => setCelular(celularMask(txt))}
            value={celular}
            style={styles.input}
          />

          <Button title="Enviar SMS" onPress={() => enviarCodigoSMS()} />
        </Form>
      ) : (
        <Form style={styles.form}>
          <Title>Verificar Celular</Title>
          <Text
            style={{
              marginBottom: 10,
              color: colors.darkGrey,
              textAlign: 'center',
              fontSize: TXT_M
            }}
          >
            Digite o código que foi enviado em um SMS para seu celular.
          </Text>

          <TextInput
            label={'Código'}
            maxLength={4}
            onChangeText={(txt) => setCodigo(txt)}
            value={codigo}
            style={styles.input}
          />

          <Button title="Validar" onPress={() => verificarCodigoSMS()} />
        </Form>
      )}
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff'
  },
  content: {
    paddingTop: TOP_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  form: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default VerificacaoPage;
